var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 93,
    viewBox: "0 0 446 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 65,
    width: 32,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5838 93.0001L58.7072 92.9722L43.0259 93.0001L58.7909 65.5896L74.5838 93.0001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 65,
    width: 33,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6396 65.0293H42.5515V92.9992H74.6396V65.0293Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5351 51.6042H29.0746V106.985H88.5351V51.6042Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 0,
    width: 49,
    height: 66
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2975 46.486L80.5829 65.086L43.0259 0L64.483 0.0279706L91.2975 46.486Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17_253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 0,
    width: 50,
    height: 66
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3812 0.000305176H42.5515V65.7296H91.3812V0.000305176Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_17_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.249 -13.984H29.0746V79.0719H105.249V-13.984Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 65,
    width: 32,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.582 93.0001L101.705 92.9722L86.0239 93.0001L101.817 65.5896L117.582 93.0001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_17_253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 65,
    width: 33,
    height: 28
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.889 65.0293H85.8006V92.9992H117.889V65.0293Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_17_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.533 51.6042H72.0725V106.985H131.533V51.6042Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 93
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7866 46.486L0 0H21.513L48.2716 46.486L21.513 93H0L26.7866 46.486Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_17_253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 93
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8297 0H0V93H48.8297V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_17_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2229 -13.9843H-13.9513V106.986H62.2229V-13.9843Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 0,
    width: 76,
    height: 93
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.569 93H161.082L134.295 46.486L107.537 0H86.0239L112.81 46.486L139.569 93Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_17_253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 0,
    width: 77,
    height: 94
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.138 0.000305176H85.8006V93.0003H161.138V0.000305176Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_17_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.033 -13.984H72.0725V106.986H175.033V-13.984Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 0,
    width: 258,
    height: 59
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M427.209 49.7316H432.312C433.656 49.7316 434.787 49.2415 435.734 48.2614C436.651 47.2812 437.109 46.1479 437.109 44.8309V15.549C437.109 14.2319 436.651 13.068 435.704 12.1185C434.756 11.1689 433.626 10.6789 432.312 10.6789H427.209V49.701V49.7316ZM445.023 44.2183C445.023 47.9244 443.74 51.0793 441.143 53.7134C438.545 56.3476 435.459 57.6646 431.823 57.6646H418.623V1.45936H431.823C435.49 1.45936 438.607 2.77643 441.173 5.41057C443.74 8.04471 445.023 11.1996 445.023 14.8751V44.2489V44.2183ZM391.367 1.42873L402.764 39.195V1.42873H411.381V57.634H402.153L390.298 21.6443V57.634H381.711V1.42873H391.398H391.367ZM374.439 57.634H365.853V1.42873H374.439V57.634ZM326.864 57.634H318.369V1.42873H330.591L338.536 41.7373L346.175 1.42873H357.939V57.634H349.414V22.3181L342.019 57.634H335.144L326.864 22.41V57.634ZM313.083 57.634H289.983V1.42873H298.416V49.2415H313.052V57.6646L313.083 57.634ZM272.841 13.5887C272.841 12.2103 272.382 11.0464 271.496 10.0969C270.61 9.14739 269.51 8.68795 268.227 8.68795C266.943 8.68795 265.874 9.14739 264.957 10.0969C264.041 11.0464 263.582 12.2103 263.582 13.5887V44.8002C263.582 46.1479 264.041 47.3118 264.957 48.2614C265.874 49.2109 266.943 49.701 268.227 49.701C269.51 49.701 270.61 49.2109 271.496 48.2614C272.382 47.3118 272.841 46.1479 272.841 44.8002V13.5887ZM269.51 0.754883C273.177 0.754883 276.324 2.07195 278.891 4.70609C281.457 7.34023 282.741 10.4951 282.741 14.2319V44.8615C282.741 48.5983 281.457 51.7838 278.86 54.3873C276.263 56.9908 273.146 58.3079 269.51 58.3079C265.874 58.3079 262.757 56.9908 260.191 54.3566C257.624 51.7225 256.371 48.5677 256.371 44.8309V14.2013C256.371 10.4645 257.654 7.27898 260.252 4.67547C262.849 2.07195 265.935 0.754883 269.51 0.754883ZM239.199 13.5887C239.199 12.2103 238.74 11.0464 237.854 10.0969C236.968 9.14739 235.868 8.68795 234.585 8.68795C233.301 8.68795 232.232 9.14739 231.315 10.0969C230.398 11.0464 229.94 12.2103 229.94 13.5887V44.8002C229.94 46.1479 230.398 47.3118 231.315 48.2614C232.232 49.2109 233.301 49.701 234.585 49.701C235.868 49.701 236.968 49.2109 237.854 48.2614C238.74 47.3118 239.199 46.1479 239.199 44.8002V13.5887ZM234.524 0.754883C238.19 0.754883 241.338 2.07195 243.904 4.70609C246.471 7.34023 247.754 10.4951 247.754 14.2319V44.8615C247.754 48.5983 246.471 51.7838 243.874 54.3873C241.276 56.9908 238.16 58.3079 234.524 58.3079C230.887 58.3079 227.771 56.9908 225.204 54.3566C222.637 51.7225 221.384 48.5677 221.384 44.8309V14.2013C221.384 10.4645 222.668 7.27898 225.265 4.67547C227.862 2.07195 230.948 0.754883 234.524 0.754883ZM196.848 39.8689V57.634H188.384V1.42873H196.848V21.4605L207.084 1.42873H216.098L204.579 24.4316L218.084 57.6646H208.184L199.354 34.8762L196.879 39.8995L196.848 39.8689Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_17_253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 0,
    width: 258,
    height: 59
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M445.024 0.785217H188.354V58.9814H445.024V0.785217Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_17_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.301 -14.5285H173.076V73.6541H460.301V-14.5285Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 75,
    width: 178,
    height: 18
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M399.648 82.2902H400.687C401.451 82.2902 401.97 81.9226 402.245 81.1569C402.337 80.8812 402.398 80.5137 402.398 80.1155C402.398 79.4417 402.245 78.921 401.909 78.5534C401.603 78.2165 401.206 78.0633 400.717 78.0633H399.678V82.2902H399.648ZM399.648 89.58H400.687C401.542 89.58 402.123 89.1512 402.428 88.263C402.551 87.9567 402.612 87.6198 402.612 87.2522C402.612 86.3333 402.428 85.6595 402.092 85.2306C401.787 84.8325 401.328 84.6487 400.717 84.6487H399.678V89.58H399.648ZM396.989 92.0304V75.5517H400.687C401.664 75.5517 402.551 75.7967 403.345 76.3174C404.017 76.7463 404.506 77.4507 404.781 78.339C404.934 78.8291 405.026 79.411 405.026 80.0849C405.026 81.1875 404.72 82.0758 404.14 82.7497C403.895 83.0253 403.589 83.2397 403.284 83.3929C403.834 83.6073 404.292 84.0055 404.69 84.6487C404.934 85.0775 405.148 85.5982 405.27 86.2721C405.331 86.609 405.362 87.0072 405.362 87.4053C405.362 88.4467 405.178 89.335 404.781 90.0701C404.476 90.6521 404.048 91.0809 403.467 91.4484C402.826 91.8466 402.214 92.0304 401.603 92.0304H397.02H396.989ZM379.511 79.3191L378.595 85.8126H380.428L379.511 79.3191ZM378.198 88.2324L377.586 92.0304H375.02L377.8 75.5517H381.223L383.973 92.0304H381.375L380.795 88.2324H378.198ZM362.003 92.0304H355.25V75.5517H357.725V89.58H362.003V92.0611V92.0304ZM339.178 79.2273C339.178 78.8291 339.055 78.4921 338.78 78.2165C338.505 77.9408 338.169 77.8183 337.772 77.8183C337.375 77.8183 337.039 77.9408 336.764 78.2165C336.489 78.4921 336.336 78.8291 336.336 79.2273V88.263C336.336 88.6612 336.489 88.9981 336.764 89.2737C337.039 89.5494 337.375 89.7026 337.772 89.7026C338.169 89.7026 338.505 89.5494 338.78 89.2737C339.055 88.9981 339.178 88.6612 339.178 88.263V79.2273ZM337.833 75.3373C338.933 75.3373 339.85 75.7355 340.614 76.5012C341.378 77.267 341.775 78.2165 341.775 79.2885V88.2936C341.775 89.3963 341.378 90.3152 340.614 91.0809C339.85 91.8466 338.903 92.2448 337.833 92.2448C336.764 92.2448 335.816 91.8466 335.053 91.0809C334.289 90.3152 333.922 89.3656 333.922 88.2936V79.2885C333.922 78.1858 334.319 77.267 335.083 76.5012C335.847 75.7355 336.764 75.3373 337.833 75.3373ZM314.672 75.5211L317.941 86.609V75.5211H320.416V91.9998H317.758L314.336 81.4326V91.9998H311.861V75.5211H314.641H314.672ZM292.916 85.0469V92.0304H290.441V75.5517H292.916V82.5659H295.88V75.5517H298.355V92.0304H295.88V85.0469H292.916ZM273.177 92.2448C272.077 92.2448 271.16 91.8466 270.396 91.1115C269.632 90.3458 269.266 89.4269 269.266 88.3242V79.2885C269.266 78.1858 269.663 77.267 270.427 76.5012C271.191 75.7355 272.107 75.3373 273.207 75.3373C274.307 75.3373 275.224 75.7355 275.988 76.5012C276.752 77.267 277.119 78.2165 277.119 79.2885V81.1569H274.552V79.2273C274.552 78.8291 274.399 78.4921 274.124 78.2165C273.849 77.9408 273.513 77.7877 273.116 77.7877C272.718 77.7877 272.382 77.9408 272.107 78.2165C271.832 78.4921 271.68 78.8291 271.68 79.2273V88.2936C271.68 88.6918 271.832 89.0287 272.107 89.3044C272.382 89.5801 272.718 89.7332 273.116 89.7332C273.513 89.7332 273.849 89.5801 274.124 89.3044C274.399 89.0287 274.552 88.6918 274.552 88.2936V86.027H277.119V88.3242C277.119 89.4269 276.721 90.3458 275.957 91.1115C275.193 91.8773 274.277 92.2448 273.177 92.2448ZM249.19 92.0304V75.5517H256.249V78.0327H251.665V82.5353H255.027V85.0162H251.665V89.5188H256.249V91.9998H249.19V92.0304ZM230.796 78.0327H228.168V75.5517H235.899V78.0327H233.271V92.0304H230.796V78.0327Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_17_253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_17_253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 75,
    width: 179,
    height: 18
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M406.065 75.0613H228.076V92.6733H406.065V75.0613Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_17_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.609 60.0532H212.859V107.59H420.609V60.0532Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.86be23a00df1a6bf06d84200e65d86cc.svg";
export { ForwardRef as ReactComponent };